// Runtime detection of "Teba login mode" for the single Old Mutual Will build.
//
// On the Teba domain the app keeps its Old Mutual Will brand but logs in the
// Teba way (industry number + SMS reset). The same behaviour can be forced on
// any domain with ?debug_teba=true for testing, and cleared with
// ?debug_teba=false. Because the query string is lost on client-side
// navigation, the debug choice is remembered for the browser session.

const TEBA_HOSTS = [
  'teba.oldmutualwill.co.za',
  'teba-staging.oldmutualwill.co.za',
];
const DEBUG_KEY = 'debug_teba';

function safeSessionGet() {
  try {
    return window.sessionStorage.getItem(DEBUG_KEY);
  } catch (e) {
    return null;
  }
}

function safeSessionSet(value) {
  try {
    if (value === null) {
      window.sessionStorage.removeItem(DEBUG_KEY);
    } else {
      window.sessionStorage.setItem(DEBUG_KEY, value);
    }
  } catch (e) {
    // sessionStorage can be unavailable (private mode / SSR); ignore.
  }
}

export function isTebaMode() {
  if (typeof window === 'undefined' || !window.location) return false;

  const host = (window.location.hostname || '').toLowerCase();
  if (TEBA_HOSTS.includes(host)) return true;

  const flag = new URLSearchParams(window.location.search || '').get(DEBUG_KEY);
  if (flag === 'true') {
    safeSessionSet('true');
    return true;
  }
  if (flag === 'false') {
    safeSessionSet(null);
    return false;
  }

  return safeSessionGet() === 'true';
}
